/**
 * BETA — vignette OCR stub.
 *
 * Mirrors the server contract in server/src/routes/ocr.routes.js: returns a
 * `confidence` score + per-field confidence map + a `stub:true / mode:"STUB"`
 * flag so the UI can show "Mode démo".
 */
import { dateOffsetYmd } from "../uuid.js";

const STUB_CONFIDENCE = 0.92;
const STUB_FIELD_CONFIDENCE = {
  nom: 0.94,
  dosage: 0.90,
  dci: 0.88,
  ppa: 0.96,
  numero_lot: 0.91,
  date_peremption: 0.89,
  num_enr_cnas: 0.93,
};

export function register(route) {
  route("POST", "/ocr/scan-vignette", (ctx) => {
    const pid = ctx.body?.produit_id;
    const p = pid ? ctx.store.data.produits.find((x) => x.id === pid) : null;
    if (p) {
      return {
        stub: true,
        mode: "STUB",
        confidence: STUB_CONFIDENCE,
        field_confidence: STUB_FIELD_CONFIDENCE,
        found: true,
        produit_id: p.id,
        nom: p.nom_commercial,
        dosage: p.dosage,
        dci: p.dci,
        forme: p.forme_pharma,
        laboratoire: p.laboratoire ?? null,
        num_enr_cnas: p.num_enr_cnas,
        ppa: p.ppa,
        numero_lot: ctx.body?.numero_lot || `LOT-DEMO-${p.id.slice(-3)}`,
        date_peremption: dateOffsetYmd(360),
        message: "OCR simulé (démo)",
      };
    }
    return {
      stub: true,
      mode: "STUB",
      confidence: STUB_CONFIDENCE,
      field_confidence: STUB_FIELD_CONFIDENCE,
      found: true,
      nom: "Doliprane 1000mg",
      dosage: "1000 mg",
      dci: "Paracétamol",
      forme: "Comprimé",
      laboratoire: "Sanofi",
      num_enr_cnas: "52A0289001",
      ppa: 184.0,
      numero_lot: "LOT-DEMO-2026",
      date_peremption: dateOffsetYmd(360),
      message: "OCR simulé (démo)",
    };
  });
}
